// extracted by mini-css-extract-plugin
export default {"Logo":"UFT6vV8s","LogoContainer":"_u1OkAO6"};